import * as React from "react";

import { useAsyncEffect } from "../../../../../../../Common/UseAsyncEffect";
import { delay } from "../../../../../../../Common/AsyncUtils";

export function showOverlay(state: UserFriendlyLoadingState): boolean {
    return (
        state === UserFriendlyLoadingState.LoadingState2 ||
        state === UserFriendlyLoadingState.LoadingState3 ||
        state === UserFriendlyLoadingState.LoadingState4 ||
        state === UserFriendlyLoadingState.LoadingState5
    );
}

export function showLoader(state: UserFriendlyLoadingState): boolean {
    return (
        state === UserFriendlyLoadingState.LoadingState3 ||
        state === UserFriendlyLoadingState.LoadingState4 ||
        state === UserFriendlyLoadingState.LoadingState5
    );
}

export enum UserFriendlyLoadingState {
    // Состояния без загрузки
    DefaultState,

    // Загрузка началась, но мы не подаём вида, может всё случится быстро и мы сразу перейдём в DefaultState
    LoadingState1,

    // Загрузка быстро не случилась - дизайблим контролы, но не показыаем лоадер
    LoadingState2,

    // Загрузка быстро не случилась - показываем быстро бегущий лоадер
    LoadingState3,

    // Загрузка долго не случилась - показываем замедленный лоадер
    LoadingState4,

    // Загрузка завершилась - показываем визуально завершение загрзуки
    LoadingState5,
}

export function useUserFriendlyLoadingState(loadingFlag: boolean): UserFriendlyLoadingState {
    const [currentState, setCurrentState] = React.useState<UserFriendlyLoadingState>(
        UserFriendlyLoadingState.DefaultState
    );

    useAsyncEffect(
        async signal => {
            if (loadingFlag == true) {
                setCurrentState(UserFriendlyLoadingState.LoadingState1);
                await delay(500);
                if (signal.aborted) {
                    return;
                }
                setCurrentState(UserFriendlyLoadingState.LoadingState2);
                await delay(500);
                if (signal.aborted) {
                    return;
                }
                setCurrentState(UserFriendlyLoadingState.LoadingState3);
                await delay(1000);
                if (signal.aborted) {
                    return;
                }
                setCurrentState(UserFriendlyLoadingState.LoadingState4);
            } else {
                if (
                    currentState != UserFriendlyLoadingState.DefaultState &&
                    currentState != UserFriendlyLoadingState.LoadingState1 &&
                    currentState != UserFriendlyLoadingState.LoadingState5
                ) {
                    setCurrentState(UserFriendlyLoadingState.LoadingState5);
                    await delay(200);
                    if (signal.aborted) {
                        return;
                    }
                }
                setCurrentState(UserFriendlyLoadingState.DefaultState);
            }
        },
        [loadingFlag]
    );

    return currentState;
}
